import type { MouseEvent } from 'react';
import React from 'react';
import { Button } from '@noths/polaris-design-system-core-components';

import { Box, BoxContainer, BoxHeader, BoxMessage } from 'src/components/atoms/Box/Box';
import { useTracking } from 'src/hooks/useTracking/useTracking';
import * as COPY from './copy';
import * as styles from './styles';

const redirect = (path: string) => {
  const applyToSellWithUsPath = window.location.pathname;
  const params = new URLSearchParams();
  params.set('redirect_url', applyToSellWithUsPath);
  window.location.assign(`${path}?${params.toString()}`);
};

const SIGNIN_URL = '/u/sign-in';
const REGISTER_URL = '/u/register';

export const SignInToContinue = () => {
  const { trackClick } = useTracking();
  const goToSignIn = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    trackClick(event);
    redirect(SIGNIN_URL);
  };
  const goToRegister = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    trackClick(event);
    redirect(REGISTER_URL);
  };

  return (
    <BoxContainer>
      <Box>
        <BoxHeader>{COPY.HEADING}</BoxHeader>
        <BoxMessage>{COPY.MESSAGE}</BoxMessage>
        <Button onClick={goToSignIn}>{COPY.SIGN_IN_CTA}</Button>
        <p css={styles.bold}>or</p>
        <Button onClick={goToRegister}>{COPY.REGISTER_CTA}</Button>
      </Box>
    </BoxContainer>
  );
};
